import React from "react";
import dateHandler from "@/composables/dateUtil";

interface RejectionReasonProps {
  rejectedBy: string | null | undefined;
  reason: string | null | undefined;
  rejectedAt: string | null | undefined;
}

const RejectionReason: React.FC<RejectionReasonProps> = ({
  rejectedBy,
  reason,
  rejectedAt,
}) => {
  const { formatDateWithTime } = dateHandler();

  if (!rejectedBy && !reason) return null;

  return (
    <div className="tw-bg-[#ffffff] tw-rounded-2xl tw-shadow-md tw-border tw-border-[#E9EAEB] tw-w-full">
      <div className="tw-px-4 tw-py-4">
        <span className="tw-text-base tw-font-semibold">Rejected Reason</span>
      </div>
      <hr className="tw-border-[#E9EAEB]" />
      <div className="tw-px-4 tw-flex tw-flex-col tw-gap-2 tw-py-4">
        <p className="tw-text-[#232323] tw-text-sm tw-font-medium">{reason}</p>
        <span className="tw-text-[#809199] tw-text-xs tw-font-medium">
          {rejectedAt && formatDateWithTime(rejectedAt)}
        </span>
      </div>
    </div>
  );
};

export default RejectionReason;
